import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ email, fullname }) {
        return (
            <feedback-form>
                <form onSubmit={this.submit}>
                    <div class='control-group'>
                        <label>Please select a subject:</label>
                        <select class='span6' name='tag'>
                            <option selected disabled>Select One</option>
                            <option value='unsub'>Please unsubscribe me from emails</option>
                            <option value='journal'>Can't find the reading/report I purchased</option>
                            <option value='keen'>Can't find my KEEN Psychic</option>
                            <option value='kcgc'>Where are my Karma Coins&reg; tokens?</option>
                            <option value='bday'>Where is my birthday gift?</option>
                            <option value='tp'>I can't redeem my TrialPay order</option>
                            <option value='fix'>
                                I need to update my purchased report with the correct birth info
                            </option>
                            <option value='wrs'>My report is advising the wrong Sun and/or Rising sign</option>
                            <option value='purchase'>I have a question regarding a purchase</option>
                            <option value='twitta'>I have a Twittascope.com issue</option>
                            <option value='app'>I have a question about one of your apps</option>
                            <option value='thanks'>Nothing! I just wanted to say thanks</option>
                            <option value='ads'>Comments regarding advertisement buttons on the site</option>
                            <option value='dislike'>Unsatisfied commentary</option>
                            <option value='mac'>Macintosh related issues</option>
                            <option value='crowley'>Crowley Tarot Deck Inquiries</option>
                            <option value='nancy'>Personal Numerology Session Requests</option>
                            <option value='close'>Close Member Account</option>
                            <option value='other'>Other (Please tell us more below)</option>
                        </select>
                        <span class='help-block error-message error-message-invalid'>Please select a subject.</span>
                    </div>
                    <div class='control-group'>
                        <label htmlFor='email'>Email:</label>
                        <input id='email' type='text' name='email' placeholder='jane@example.com' value={email} />
                        <span class='help-block error-message error-message-empty'>
                            Please enter your email address
                        </span>
                        <span class='help-block error-message error-message-invalid'>
                            Please enter a valid email address
                        </span>
                    </div>
                    <label htmlFor='phone'>Phone:</label>
                    <input id='phone' type='text' name='phone' placeholder='555-555-5555' />
                    <label htmlFor='name'>Name:</label>
                    <input id='name' type='text' name='name' placeholder='Jane Doe' value={fullname} />
                    <p>
                        Please fill out the form below, providing us with as many details as possible so we can help
                        you better
                    </p>
                    <label>Comments:</label>
                    <textarea rows='5' name='comment' />
                    <button type='submit'>Send Feedback</button>
                    <button type='button' onClick={this.clear}>Clear Form</button>
                </form>
            </feedback-form>
        );
    }

    submit = (e) => {
        e.preventDefault();

        const $button = $('[type=submit]', 'feedback-form')
            .text('Submitting…')
            .attr('disabled', 'disabled');

        const form_json = this.validateAndSerialize($('form', 'feedback-form'));

        if (form_json) {
            $.ajax({
                url: '/service/feedback/submit',
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(form_json),
            }).then(function (data) {
                $('#tab-feedback').html(data.html);

                $('html, body').animate({ scrollTop: $('.container-main_content').offset().top }, 200);
            }, function () {
                $button.text('Send Feedback').removeAttr('disabled');
            });
        } else {
            $button.text('Send Feedback').removeAttr('disabled');
        }
    }

    clear = () => {
        const error_classes = this.props.error_classes;

        $('input, textarea, select', 'feedback-form').val('');
        $('.control-group', 'feedback-form').removeClass(error_classes.join(' '));
    }

    validateAndSerialize = ($form) => {
        const Cookies = require('js-cookie');

        const $email_field = $form.find('input[name=email]', 'feedback-form');
        const $tag_field = $form.find('select[name=tag]', 'feedback-form');
        const subject = $tag_field.find('option:selected').text();
        const tag = $tag_field.find('option:selected').val();

        const valid_email = this.validateEmail($email_field);
        const valid_tag = this.validateTag($tag_field);

        if (valid_email && valid_tag) {
            return {ticket: {
                email: $email_field.val(),
                subject: subject + ' (key:' + tag + ')',
                name: $('input[name=name]', 'feedback-form').val(),
                page: Cookies.get('feedback-url'),
                phone: $('input[name=phone]', 'feedback-form').val(),
                description: $('textarea[name=comment]', 'feedback-form').val(),
                //browser: UAParser.getBrowser(),
                //os: UAParser.getOS(),
            }};
        }

        $('html, body').animate({ scrollTop: $form.offset().top }, 200);

        return null;
    }

    validateTag = ($select) => {
        const error_classes = this.props.error_classes;
        const tag = $select.val();
        const $control_group = $select.closest('.control-group');

        $control_group.removeClass(error_classes.join(' '));

        if (!tag) {
            $control_group.addClass('error-input error-invalid');
            return false;
        }

        return true;
    }

    validateEmail = ($field) => {
        const error_classes = this.props.error_classes;
        const email = $field.val();
        const $control_group = $field.closest('.control-group');

        $control_group.removeClass(error_classes.join(' '));

        if (email.length === 0) {
            $control_group.addClass('error-input error-empty');
            return false;
        }

        if (!/\S+@\S+\.\S+/.test(email)) {
            $control_group.addClass('error-input error-invalid');
            return false;
        }

        return true;
    }
}

const mapStateToProps = (state) => ({
    error_classes: [ 'error-input', 'error-empty', 'error-invalid' ],
    email: state.user && state.user.email,
    fullname: state.user && state.user.fullname,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/feedback/form.js